<template>
    <div id="page">
        <div class="flex pad14 alc" id="toolH">
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    clearable
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>
            <el-select style="width: 145px" v-model="i_state"  class="marr4" size="mini" clearable filterable :placeholder="$t('form_please_select')">
                <el-option
                        v-for="item in stateData"
                        :key="item.i_state"
                        :label="item.vc_name"
                        :value="item.i_state">
                </el-option>
            </el-select>
            <el-select  @change="changeData($event,'gs')" @clear="clearsearch('gs')" class="marr4" v-model="vc_gsname" size="mini" clearable filterable placeholder="请选择公司">
                <el-option
                        v-for="item in compsData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-select  @change="changeData($event,'kh')" @clear="clearsearch('kh')" class="marr4" v-model="vc_khname" size="mini" clearable filterable placeholder="请选择客户">
                <el-option
                        v-for="item in khData"
                        :key="item.i_khid"
                        :label="item.vc_khname"
                        :value="item.i_khid">
                </el-option>
            </el-select>
            <!--<el-input  class="marr4" style="width: 280px"  v-model="vc_search" :placeholder="$t('invoiceEntry_please_enter_customer_name/invoice_number/product_name/submitter_search')" clearable size="mini"></el-input>-->
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="goDd('add')">{{'新增'}}</el-button>
        </div>
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}">
            <el-table-column
                    prop="i_id"
                    :label="'ID'"
                    show-overflow-tooltip
                    width="70">
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    :label="'公司'"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_khname"
                    :label="'客户'"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    :label="'挂牌时间'"
                    show-overflow-tooltip
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    :label="'挂牌录入人'"
                    show-overflow-tooltip
                    width="108">
            </el-table-column>
            <el-table-column
                    prop="dt_starttime"
                    :label="'开始时间'"
                    show-overflow-tooltip
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="dt_endtime"
                    :label="'结束时间'"
                    show-overflow-tooltip
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="i_state"
                    :label="'状态'"
                    show-overflow-tooltip
                    width="80">
                <template slot-scope="scope">
                    <span>{{scope.row.i_state==0?'待提交':(scope.row.i_state==1?'已提交':'已作废')}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="120"
                    :label="$t('form_operate')">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" @click="goDd(scope.row.i_state==0?'edit':'watch',scope.row)">{{scope.row.i_state==0?$t('button_edit'):'查看'}}</el-button>
                    <el-button  type="text" size="small" v-if="scope.row.i_state==1" @click="goDd('copy',scope.row)">{{'复制'}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="10vh"
                :class="baseerp+'div'"
                width="90%"
                :title="title"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="confirm({type:'back'})"
                v-if="dialogVisible">
            <add-gp :Data="Data" @confirm="confirm"></add-gp>
        </el-dialog>
    </div>

</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import addGp from "./addGp";
    export default {
        components: {
            addGp,
        },
        data() {
            return {
                maxDialogHeight: 0,
                tableHeight:0,
                tableData:[],
                baseerp:"",
                file_root:"",
                mid:0,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                title:'',
                dialogVisible:false,
                loading:false,
                Data:{},
                stateData:[
                    {i_state:null,vc_name:'全部'},
                    {i_state:'0',vc_name:'待提交'},
                    {i_state:'1',vc_name:'已提交'},
                    {i_state:'-1',vc_name:'已作废'},
                ],
                i_state:null,
                vc_state:"全部",
                compsData:[],
                khData:[],
                i_gsid:null,
                vc_gsname:'',
                i_khid:null,
                vc_khname:'',
                kh_gsid:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
            }
        },
        watch: {
        },
        activated(){
        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root = file_root;
            this.getList();
            this.getCompanyList();
            this.getkhlist();

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setDialogHeight);
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight;
                const otherHeight =230;
                this.tableHeight = window.innerHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
            },
            goDd(type,row){
                //console.log('row',row);
                if(type=="add"){
                    this.title='新增'
                }else if(type=='edit'){
                    this.title='编辑'
                } else if(type=='watch'){
                    this.title='查看'
                } else if(type=='copy'){
                    this.title='复制挂牌'
                }
                let map={
                    type:type,
                    row:row,
                    maxDialogHeight:this.maxDialogHeight,
                }
                this.Data=map;
                this.dialogVisible=true;
            },
            confirm({type}){
                this.Data={};
                this.dialogVisible=false;
                if(type=='save'){
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                }
            },
            issameid(gs,kh){
                if(gs==kh){this.$message.error('公司和客户不能为同一个');return true;}
                return false;
            },
            changeData(e,type){
                if (type == 'kh') {
                    this.i_khid = e;
                    let choo = this.khData.filter(item => {
                        return item.i_khid == e
                    });
                    if (choo.length > 0) {
                        this.vc_khname = choo[0].vc_khname;
                        this.kh_gsid = choo[0].i_gsid;
                    } else {
                        this.vc_khname = '';
                        this.kh_gsid = 0;
                    }
                    let thesame = this.issameid(this.i_gsid,this.kh_gsid)
                    if(thesame){
                        this.i_khid = null;
                        this.vc_khname = '';
                    }
                }
                if(type=='gs'){
                    this.i_gsid=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_gsname=choo[0].vc_name;
                    }else{
                        this.vc_gsname='';
                    }
                    let thesame = this.issameid(this.i_gsid,this.kh_gsid)
                    if(thesame){
                        this.i_gsid = null;
                        this.vc_gsname = "";
                    }
                }
                //this.getList();
            },
            gosearch(){
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if (type == 'kh') {
                    this.i_khid = null;
                    this.vc_khname = '';
                    this.kh_gsid = 0;
                }
                if (type == 'gs') {
                    this.i_gsid = null;
                    this.vc_gsname = "";
                }
                if(type=='sou'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                //this.getList();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            async getList(){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    'i_state':this.i_state,
                    "i_gsid": this.i_gsid,
                    'i_khid':this.i_khid,
                    'dt_starttime':this.dt_startdate?this.dt_startdate+' 00:00:00':'',
                    'dt_endtime':this.dt_enddate?this.dt_enddate+' 23:59:59':'',
                    //"vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                };
                let res = await API.list(param);
                if (res.code==1){
                    this.tableData=res.data;
                    this.tableTotal=res.total;
                    this.loading=false;
                    this.setDialogHeight();
                    window.addEventListener('resize', this.setDialogHeight);
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            async getCompanyList() {
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getkhlist() {
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.khData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                //this.currentPage=1;
                //this.tableData=[];
                //this.getList();
            },
        },
    }
</script>

<style  lang="scss" scoped>
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .pad14{
        padding: 4px;
    }
    .alc{
        align-items: center;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }

</style>